import { MenuSubItem } from './menu-subitem.model';
import { MenuItem } from './menu.item.model';

export interface StorageMenuSection {
  title: string;
  items: MenuItem[];
}

export const products: MenuSubItem[] = [
  {
    icon: 'cube',
    route: '/materials/order',
    name: 'nav.materials.order',
  },
  {
    icon: 'cube',
    route: '/materials/process',
    name: 'nav.materials.process',
  },
  {
    icon: 'cube',
    route: '/materials/products',
    name: 'nav.materials.products',
  },
];

export const items: MenuItem[] = [
  {
    icon: 'home',
    name: 'nav.home',
    route: '/home',
  },
  {
    icon: 'cube',
    name: 'nav.materials.title',
    children: products,
  },
  {
    icon: 'help-circle-outline',
    name: 'nav-item.support.help',
    route: '/support',
  },
];

export const sections: StorageMenuSection[] = [
  {
    title: 'nav-item.operational.home',
    items: [
      { icon: 'home', name: 'nav.home', route: '/home' },
    ],
  },
  {
    title: 'nav-item.system.title',
    items: [
      { icon: 'cube', name: 'nav.materials.order', route: '/materials/order' },
      { icon: 'cube', name: 'nav.materials.process', route: '/materials/process' },
      { icon: 'cube', name: 'nav.materials.products', route: '/materials/products' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      { icon: 'help-circle-outline', name: 'nav-item.support.help', route: '/support' },
    ],
  },
];

export const storageMenu = {
  sections,
  items,
};
